var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSafePayment = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#48D597",
  d: "M13.022 23.702c5.684-3.356 8.477-8.704 8.975-14.734.032-2.78-.16-3.251-1.445-4.073A1103 1103 0 0 0 13.07.316c-.626-.385-1.316-.437-1.959-.052a1282 1282 0 0 0-8.06 4.963c-.722.455-1.027 1.206-1.043 2.098-.032.909.032 1.8.16 2.674.9 6.065 3.774 10.662 8.735 13.668.706.42 1.413.455 2.119.035"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#414141",
  d: "M12 19c3.753 0 6.5-2.747 6.5-6.5S15.753 6 12 6s-6.5 2.747-6.5 6.5S8.247 19 12 19m0-1.35c-2.526 0-4.17-2.035-4.17-5.15S9.474 7.35 12 7.35s4.17 2.035 4.17 5.15-1.644 5.15-4.17 5.15"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M18.413 6.71a1 1 0 0 1 .177 1.403l-5.812 7.5a1 1 0 0 1-1.57.013L9.02 12.898a1 1 0 1 1 1.56-1.251l1.394 1.738 5.036-6.498a1 1 0 0 1 1.403-.177",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSafePayment);
export default ForwardRef;